export default __webpack_public_path__ + "static/media/VIDEO.add2ac24.svg";